import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { RADIUS, SURFACE, TEXT } from '../../theme/tokens'
import Overline from './Overline'

/**
 * One fact on the review step (event type, recipients, file), with an accent
 * rule along its top. `large` shows a number big; long text is cut with an
 * ellipsis and shown in full on hover.
 */
const ReviewTile = ({ label, value, accent, valueColor, large }) => (
    <Paper
        elevation={0}
        sx={{
            p: 2,
            height: '100%',
            borderRadius: `${RADIUS.md}px`,
            background: SURFACE.subtle,
            border: `1px solid ${SURFACE.border}`,
            borderTop: `3px solid ${accent}`,
        }}
    >
        <Overline component="p" sx={{ color: TEXT.faint, fontWeight: 400 }}>
            {label}
        </Overline>
        <Typography
            variant={large ? 'h5' : 'body2'}
            title={large ? undefined : String(value)}
            sx={{
                fontWeight: 700,
                mt: 0.5,
                color: valueColor ?? TEXT.primary,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
            }}
        >
            {value}
        </Typography>
    </Paper>
)

ReviewTile.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    accent: PropTypes.string.isRequired,
    valueColor: PropTypes.string,
    large: PropTypes.bool,
}

export default ReviewTile
